<template>
  <div class="nav">
    <ul>
      <li v-for="(item,index) in list"
          :key="item.title"
          :class="{on:currentIndex==index}"
          @click="jump(index)">
        {{item.name}}
      </li>
    </ul>
  </div>
</template>

<script>
import { scrollTo,getOffsetTop } from '@/assets/js/tools'
import list from "@/assets/data";
export default {
  data () {
    return {
      currentIndex: 0,
      list
    }
  },
  created(){
  },
  mounted () {
    const blockList = this.list.map(item=>{
      return {
        id: item.title,
        top : getOffsetTop(document.querySelector(`#${item.title}`))
      }
    })
    window.addEventListener('scroll',()=>{
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop 
      blockList.forEach((el, i) => {
        if (blockList[0].top >= scrollTop) {
          this.currentIndex = 0
        } else if (blockList[blockList.length - 1].top < scrollTop) {
          this.currentIndex = blockList.length - 1
        } else if (
          i > 0 &&
          i < blockList.length - 1 &&
          blockList[i - 1].top < scrollTop &&
          el.top - 5 <= scrollTop &&
          blockList[i + 1].top > scrollTop
        ) {
          this.currentIndex = i
        }
      })
    },false)
  },
  methods: {
    jump (index) {
      const id = this.list[index].title
      const ele = document.querySelector(`#${id}`)
      const targetY = getOffsetTop(ele)
      scrollTo(targetY)
      this.currentIndex = index
    }
  }
}
</script>

<style lang="less" scoped>
.nav {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 101px;
  height: 393px;
  background: url(../../../assets/images/pc/nav.png) no-repeat center center;
  background-size: contain;
  ul {
    padding: 76px 14px 0;
    li {
      color: #fff;
      font-weight: bold;
      cursor: pointer;
      & + li {
        margin-top: 22px;
      }
      &.on {
        color: #80f5ff;
      }
    }
  }
}
</style>